import { TableViewStore, BaseListViewStore, BaasicDropdownStore } from "core/stores";
import { HistoryService } from "application/history/services";
import _ from 'lodash';
import { toDate } from 'core/utils';
import { action } from 'mobx';
import {GridMultilineCell} from 'core/components';
import { FacilityOrderService } from "../../facility-order/services";
import { NikoPatientDetailService, NikoPatientTemplateService } from "../../niko-patient/services";

class NikoOrderHistoryListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const historyService = new HistoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            autoInit: true,
            name: 'niko-template-history',
            routes: {},
            actions: () => {
                return {
                    find: async params => {
                        const nikoFacilityOrderId = this.rootStore.routerStore.routerState.params.id;
                        const response = await historyService.findNikoOrderHistory(_.extend(params, {recordId: nikoFacilityOrderId}));

                        const responseData = _.extend(response.data, {
                            item: _.map(response.data.item, (item => {
                                return _.extend(
                                    item, {
                                        eventDate: item.eventDate && toDate(item.eventDate, true)
                                    }
                                );
                            }))
                        });

                        if (nikoFacilityOrderId) {
                            this.setTitle(nikoFacilityOrderId);
                        }

                        return responseData;
                    }
                };
            },
        });

        this.queryUtility.onResetFilter = ()=> {
            this.facilityOrderPatientStore.setValue(null);
            this.facilityOrderPatientStore.filterTerm = '';

            this.patientTemplateStore.setValue(null);
            this.patientTemplateStore.filterTerm = '';

			this.onChangePatient();
        }

        this.nikoPatientDetailService = new NikoPatientDetailService(this.rootStore.application.baasic.apiClient);
        this.facilityOrderPatientStore = new BaasicDropdownStore({ filterable: true }, {
            fetchFunc: async(term) => {
                const facilityOrderId = this.rootStore.routerStore.routerState.params.id;
                const response = await this.nikoPatientDetailService.find({ facilityOrderId: facilityOrderId, hasTemplateInFacilityOrder: true, searchQuery: term, rpp: 25, embed: "nikoPatient" });
                
                this.patientTemplateStore.filterAsync();
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.nikoPatient.lastName + ' ' + item.nikoPatient.firstName
                    };
                });
                }
        });

        this.patientTemplateService = new NikoPatientTemplateService(rootStore.application.baasic.apiClient);
        this.patientTemplateStore = new BaasicDropdownStore({ filterable: true }, 
        {
            fetchFunc: async(term) => {
                const facilityOrderId = this.rootStore.routerStore.routerState.params.id;
                
                const response = await this.patientTemplateService.find({ facilityOrderId: facilityOrderId, nikoPatientDetailId: this.queryUtility.filter.patientId, subCategoryName: term, rpp: 25, embed: 'SubCategory' });				
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.itemCategoryName
                    };
                });
            }
        });

        this.setTableStore(
            new TableViewStore(this.queryUtility, {
                columns: [
                    {
                        key: 'eventDate',
                        title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.DATE_OF_CHANGE",
                        width: 150						
                    },
                    {
                        key: 'username',
                        title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.CORE_USER",
                        width: 150,
                        sortable: false
                    },
                    {
                        key: 'tableName',
                        title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.ENTITY",
                        width: 150,
                        sortable: false
                    },
                    {
                        key: 'patient',
                        title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.PATIENT",
                        width: 150,
                        sortable: false
                    },
                    {
                        key: 'subCategory',
                        title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.CATEGORY",
                        width: 100,
                        sortable: false
                    },
                    {
                        key: 'itemId',
                        title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.ITEM_ID",
                        width: 100,
                        sortable: false
                    },
                    {
                        key: 'changes',
                        title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.DESCRIPTION",
                        cell: GridMultilineCell,
                        sortable: false
                    }					
                ],
            })
        );
    }

    @action.bound
    async setTitle(nikoFacilityOrderId) {
		const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);	

        const facilityOrder = (await facilityOrderService.get(nikoFacilityOrderId, { embed: 'Facility' })).data;
		const facilityOrderTitle = `${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`

        this.rootStore.titleStore.setTitle(`Facility Order History - ${facilityOrder.facility.name}`);
		this.rootStore.viewStore.setNavigationOptions({
			title: facilityOrderTitle
		});		
    }
    
	@action.bound
	onChangePatient() {
		this.queryUtility.filter.set('patientTemplateId', null);
		this.patientTemplateStore.setValue(null);
		this.patientTemplateStore.filterAsync();
	}
}

export default NikoOrderHistoryListViewStore;